import { assign } from 'xstate';

import usageEstimates from './setUsageEstimatedValues.data';
import { FlowConsumerContextEnergy } from '../../context';
import { energyTypeIncludes } from '../helpers';
import { BuildingAgeType, EnergyType } from '../types';

export const setValues = (currentValues: FlowConsumerContextEnergy): FlowConsumerContextEnergy => {
  const data: FlowConsumerContextEnergy = {};

  const { energyType = EnergyType.Electricity, hasDoubleMeter, residents, buildingAge, buildingType } = currentValues;

  // If current "buildingAge" is "Unknown" then "Between1945And2000" will be used instead
  const matcher = (estimate: FlowConsumerContextEnergy) =>
    estimate.residents === residents &&
    estimate.buildingType === buildingType &&
    estimate.buildingAge ===
      (buildingAge === BuildingAgeType.Unknown ? BuildingAgeType.Between1945And2000 : buildingAge);

  const estimatedValues = usageEstimates.find(matcher);

  if (estimatedValues) {
    const {
      usageElectricityHigh = 0,
      usageElectricityLow = 0,
      usageGas = 0,
      usageWarmth = 0,
      usageWater = 0,
    } = estimatedValues;

    if (energyTypeIncludes(energyType, EnergyType.Electricity)) {
      if (hasDoubleMeter) {
        data.usageElectricityHigh = usageElectricityHigh;
        data.usageElectricityLow = usageElectricityLow;
      } else {
        const electricityUsage = usageElectricityLow + usageElectricityHigh;
        data.usageElectricityHigh = electricityUsage;
        data.usageElectricityLow = undefined;
      }
    }

    if (energyTypeIncludes(energyType, EnergyType.Gas)) {
      data.usageGas = usageGas;
    }

    if (energyTypeIncludes(energyType, EnergyType.Warmth)) {
      data.usageWarmth = usageWarmth;
    }

    if (energyTypeIncludes(energyType, EnergyType.TapWater)) {
      data.usageWater = usageWater;
    }
  }

  return data;
};

export const setUsageEstimatedValues = assign(({ context }) => {
  if (!context.isUsageKnown) {
    return { ...context, ...setValues({ ...context }) };
  }

  return context;
});
